import React, { Fragment } from 'react'
import { useHero, HeroProps } from './useHero'
import PricingModal from 'components/Modal/PricingModal/PricingModal'
import styles from './Hero.module.scss'
import heroImg from 'img/Landing/hero.webp'

const Hero: React.FC<HeroProps> = (props: HeroProps) => {
  const {
    showModal,
    selectedPlan,
    setShowModal,
    handleStartClick,
    handlePlanChange,
  } = useHero(props)

  return (
    <Fragment>
      <section id='hero' className={styles.hero}>
        <div className={`${styles.container} container`}>
          <div className='row align-items-center'>
            <div className={`${styles['hero-content']} col-lg-6`}>
              <div className={styles.subtitle}>
                <span>DIGITAL MENU</span>
              </div>

              <h1 className={styles.title}>
                MODERN <span className={styles.highlight}>MOBILE</span> MENU
              </h1>

              <div className={styles.description}>
                <p>
                  Say goodbye to outdated PDFs and hard-to-edit menus. Create a
                  modern, mobile-friendly menu that looks amazing and updates
                  instantly — no tech skills needed.
                </p>
              </div>

              <div className={styles['hero-buttons']}>
                <a href='/demo' className={styles['primary-btn']}>
                  View Live Demo
                  <i className='bi bi-chevron-right'></i>
                </a>
                <button
                  type='button'
                  className={styles['secondary-btn']}
                  onClick={(e) => {
                    e.preventDefault()
                    handleStartClick()
                  }}
                >
                  Get Started Free
                </button>
              </div>
            </div>

            <div className={`${styles['hero-visual']} col-lg-6`}>
              <div className={styles['image-wrapper']}>
                <img
                  src={heroImg}
                  alt='Creative Design'
                  className={styles['main-image']}
                />

                <div
                  className={`${styles['floating-element']} ${styles['top-left']}`}
                >
                  <i className='bi bi-star-fill'></i>
                </div>

                <div
                  className={`${styles['floating-element']} ${styles['bottom-right']}`}
                >
                  <i className='bi bi-circle-fill'></i>
                </div>

                <div className={styles['experience-badge']}>
                  <span className={styles['years']}>2025</span>
                  <span className={styles['text']}>Freshly Released</span>
                </div>
              </div>

              <div className={styles['client-counter']}>
                <div className={styles['counter-number']}>
                  <span>100%</span>
                </div>
                <div className={styles['counter-text']}>
                  <span>Fresh Launch</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showModal && (
        <PricingModal
          title='Choose Your Plan'
          plan={selectedPlan}
          setShowModal={setShowModal}
          handlePlanChange={handlePlanChange}
        />
      )}
    </Fragment>
  )
}

export default Hero
